import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from "react";
export var useDetectAdBlock = function useDetectAdBlock() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      adBlockDetected = _useState2[0],
      setAdBlockDetected = _useState2[1];

  useEffect(function () {
    // grab a domain from https://github1s.com/gorhill/uBlock/blob/master/docs/tests/hostname-pool.js
    var url = "https://www3.doubleclick.net";
    fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store"
    }) // .then((res) => {
    //   if (process.env.NODE_ENV !== "production") {
    //     console.log(res);
    //   }
    // })
    .catch(function (err) {
      // if (process.env.NODE_ENV !== "production") {
      //   console.log(err);
      // }
      setAdBlockDetected(true);
    });
  }, []);
  return adBlockDetected;
};